/**
 * Virtually grouped VoyageBulks of type Rob on the same date.
 */
var VRC = VRC || {};
VRC.RobRow = function(params){
	var _date;
	var _remarks;
	var _bulkTankIds;
	var _entries;


	var initEntries = function (bulkTankIds) {
		_entries = [];
		for (var ii = 0; ii < bulkTankIds.length; ii++) {
			_entries[ii] = {bulkTankId : bulkTankIds[ii]};
		}
	};
	var init = function(params){

		params = params || {};
		setDate(params.date);
		setRemarks(params.remarks);
		setBulkTankIds(params.bulkTankIds);
		setEntries(params.voyageBulkOnDate);
	};

	var getEntries = function () {
		return _entries;
	};

	var setEntries = function (voyageBulkOnDate) {
		initEntries(_bulkTankIds);
		_.each(voyageBulkOnDate, function(voyageBulk){
			var bulkTankId = voyageBulk.getBulkTankId();
			var bulkTankPos = getBulkTankIndex(bulkTankId);
			_entries[bulkTankPos] = voyageBulk;
		});
	};

	var getBulkTankIndex = function (bulkTankId) {
		bulkTankId = parseInt(bulkTankId);
		return _.indexOf(_bulkTankIds, bulkTankId);
	};
	var getEntryByBulkTankId = function(bulkTankId){
		bulkTankId = parseInt(bulkTankId);
		var bulkTankPos = getBulkTankIndex(bulkTankId);
		return  _entries[bulkTankPos];
	};

	var getBulkTankIds = function () {
		return _bulkTankIds;
	};

	var setBulkTankIds = function (bulkTankIds) {
		_bulkTankIds = bulkTankIds;
	};

	var getDate = function () {

		return _date;
	};

	var setDate = function (date) {

		_date = date;

		_.each(_entries, function(entry){
			if(hasVoyageBulk(entry)){

				entry.setDate(date)
			}
		})
	};
	var setRemarks = function (remarks) {

		_remarks = remarks;

		_.each(_entries, function(entry){

			if(hasVoyageBulk(entry)){
				entry.setRemarks(remarks)
			}
		})
	};


	var hasVoyageBulk = function(entry){
		return entry.toJson !== undefined;
	};

	var addVoyageBulk = function(bulkTankId, date, qty, remarks){
		var voyageBulk = VRC.VoyageBulk();
		voyageBulk.setAction(g_actions.rob);
		voyageBulk.setBulkTankId(bulkTankId);
		voyageBulk.setDate(date);
		voyageBulk.setRemarks(remarks);
		voyageBulk.setQtyRob(qty);
		voyageBulk.setValueQty(qty);
		var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
		bulkTank.addContent(voyageBulk);

		var bulkTankIndex = getBulkTankIndex(bulkTankId);
		_entries[bulkTankIndex] = voyageBulk;
	};

	var getEntry = function(bulkTankId){
		var bulkTankIndex = getBulkTankIndex(bulkTankId);
		return  _entries[bulkTankIndex];
	};

	var removeAllVoyageBulk = function(){
		_.each(_entries, function(entry){
			if(hasVoyageBulk(entry)){
				var bulkTankId = entry.getBulkTankId();
				var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
				bulkTank.removeContent(entry);
			}
		});
	};

	var removeVoyageBulk = function(bulkTankId){
		var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
		var voyageBulk =  getEntry(bulkTankId);
		bulkTank.removeContent(voyageBulk);
	};

	var toJson = function(){
		return {
			date : getDate(),
			remarks : _remarks,
			robEntries : _.map(_entries, function(entry){
				var json = hasVoyageBulk(entry) ? entry.toJson() : entry;
				return json;
			})

		}
	};

	init(params);
	return {
		init : init,
		getDate: getDate,
		setDate: setDate,
		getEntries : getEntries,
		getEntryByBulkTankId : getEntryByBulkTankId,
		toJson : toJson,
		hasVoyageBulk : hasVoyageBulk,
		addVoyageBulk : addVoyageBulk,
		removeVoyageBulk : removeVoyageBulk,
		removeAllVoyageBulk : removeAllVoyageBulk,
		setRemarks : setRemarks
	}
};